import styles from "@buddieshr/styles/components/slackPreview.module.scss";

export const SlackAlias = ({ name }) => (
  <span className={styles.Slack_alias}>@{name}</span>
);

export default SlackAlias;
